import React, { useState } from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const mailtoLink = `mailto:shashyv@gmail.com?subject=Contact from ${formData.name}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-container">
      <h2 className="contact-title">Get In Touch</h2>
      <p className="contact-subtitle">
        Feel free to reach out for collaborations or just a friendly chat!
      </p>

      <div className="contact-content">
        <div className="contact-info">
          <div className="info-item">
            <FontAwesomeIcon icon={faEnvelope as IconProp} className="info-icon" />
            <div>
              <h3>Email</h3>
              <a href="mailto:shashyv@gmail.com">shashyv@gmail.com</a>
            </div>
          </div>

          <div className="info-item">
            <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} className="info-icon" />
            <div>
              <h3>Location</h3>
              <p>India</p>
            </div>
          </div>

          <div className="contact-social">
            <a href="https://github.com/svenkat19" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FontAwesomeIcon icon={faGithub as IconProp} size="lg" />
            </a>
            <a href="https://www.linkedin.com/in/shashankvenkat18/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin as IconProp} size="lg" />
            </a>
            <a href="https://www.facebook.com/shaz.venk/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook as IconProp} size="lg" />
            </a>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message"
              rows={6}
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="submit-btn">Send Message</button>
        </form>
      </div>

      <p className="copyright-text">
        © {new Date().getFullYear()} Shashank Venkat. Made with{' '}
        <FontAwesomeIcon icon={faHeart as IconProp} className="heart-icon" /> using React & TypeScript
      </p>
    </div>
  );
};

export default Contact;
